"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _bottomBlob = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/bottom-blob.svg"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: left;\n    margin: 35px 0;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: bold;\n  line-height: 44px;\n  text-align: center;\n  margin-top: 75px;\n  margin-bottom: 35px;\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  z-index: 1;\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-width: 1004px;\n  margin-right: auto;\n  margin-left: auto;\n  position: relative;\n  padding-top: 40px;\n  clear: both;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none !important;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  padding-bottom: 80px;\n  margin-top: -24px;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledQuestionBackground = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "Faq__StyledQuestionBackground",
  componentId: "sc-5bsfmt-0"
})(_templateObject(), _responsiveBreakpoints.default.phone(_templateObject2()));

var QuestionContainer = _styledComponents.default.div.withConfig({
  displayName: "Faq__QuestionContainer",
  componentId: "sc-5bsfmt-1"
})(_templateObject3());

var QuestionContent = _styledComponents.default.div.withConfig({
  displayName: "Faq__QuestionContent",
  componentId: "sc-5bsfmt-2"
})(_templateObject4());

var Title = _styledComponents.default.h1.withConfig({
  displayName: "Faq__Title",
  componentId: "sc-5bsfmt-3"
})(_templateObject5(), _responsiveBreakpoints.default.phone(_templateObject6()));

var Faq = function Faq(_ref) {
  var children = _ref.children;
  return _react.default.createElement(QuestionContainer, {
    "data-selenium-id": "faq-container"
  }, _react.default.createElement(StyledQuestionBackground, {
    src: _bottomBlob.default
  }), _react.default.createElement(QuestionContent, null, _react.default.createElement(Title, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.faq.title"
  })), children));
};

Faq.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = Faq;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/Faq.js
// module id = 205
// module chunks = 5 6